import { render, staticRenderFns } from "./admin-built-in-rate-cards.vue?vue&type=template&id=ea02a99c&scoped=true&"
import script from "./admin-built-in-rate-cards.vue?vue&type=script&lang=js&"
export * from "./admin-built-in-rate-cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea02a99c",
  null
  
)

export default component.exports